import { Props } from "."

export const mockProps: Props = {
  src: "/mocks/module-blue-dark.png",
  width: 416,
  height: 208,
  priority: true,
  className: "",
}
